
(function () {
  var selector = '.bss-error-msg, .bss-warning-msg';
  var requiredClass = '.po-required';
  var headerOffset = 120;   // height of your sticky header
  var toastDuration = 4000; // ms the banner stays visible
  var timer = null;
  var toastTimer = null;
  var toast = null;

  // ---------- Floating message banner ----------
  function createToast() {
    toast = document.createElement('div');
    toast.id = 'bss-scroll-toast';
    toast.setAttribute('role', 'alert');
    toast.style.cssText = [
      'position:fixed', 'top:20px', 'left:50%', 'transform:translate(-50%,-20px)',
      'background:#d62828', 'color:#fff', 'padding:12px 20px', 'border-radius:6px',
      'font-size:14px', 'z-index:99999', 'box-shadow:0 4px 12px rgba(0,0,0,.25)',
      'opacity:0', 'pointer-events:none', 'transition:opacity .3s, transform .3s',
      'max-width:90%', 'text-align:center'
    ].join(';');
    document.body.appendChild(toast);
  }

  function showToast(text) {
    if (!toast) createToast();
    toast.textContent = text;
    toast.style.opacity = '1';
    toast.style.transform = 'translate(-50%,0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translate(-50%,-20px)';
    }, toastDuration);
  }

  // ---------- Find scrollable parent boxes ----------
  function getScrollableParents(el) {
    var parents = [];
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      var canScrollY = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
      if (canScrollY) parents.push(node);
      node = node.parentElement;
    }
    return parents;
  }

  // ---------- Find the .po-required option that is missing ----------
  function findRequiredTarget(errorEl) {
    // 1) error is inside the .po-required wrapper
    var inside = errorEl.closest(requiredClass);
    if (inside) return inside;

    // 2) error sits next to the option: use the nearest .po-required before it
    var all = document.querySelectorAll(requiredClass);
    for (var i = all.length - 1; i >= 0; i--) {
      if (all[i].compareDocumentPosition(errorEl) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return all[i];
      }
    }

    // 3) fall back to the error itself
    return errorEl;
  }

  // ---------- Main handler ----------
  function handleError() {
    var errors = document.querySelectorAll(selector);
    var first = null;
    var messages = [];

    errors.forEach(function (el) {
      if (el.offsetParent === null) return; // hidden
      var small = el.querySelector('small');
      var text = (small || el).textContent.trim();
      if (!text) return;
      messages.push(text);
      if (!first) first = el;
    });

    if (!first) return;

    var target = findRequiredTarget(first);

    // 1) Scroll the inner options box so the missing option is at its top
    var scrollParents = getScrollableParents(target);
    scrollParents.forEach(function (box) {
      var boxTop = box.getBoundingClientRect().top;
      var targetTop = target.getBoundingClientRect().top;
      box.scrollTo({
        top: box.scrollTop + (targetTop - boxTop) - 10,
        behavior: 'smooth'
      });
    });

    // 2) Scroll the page so the whole box is visible below the header
    var pageTarget = scrollParents.length ? scrollParents[scrollParents.length - 1] : target;
    var top = pageTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });

    // 3) Show the message
    showToast(messages[0]); // use messages.join(' • ') to show all errors
  }

  // ---------- Watch for the error appearing ----------
  function startObserver() {
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        if (m.type === 'attributes') {
          return m.target.matches && m.target.matches(selector);
        }
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches(selector) || n.querySelector(selector));
        });
      });
      if (relevant) {
        clearTimeout(timer);
        timer = setTimeout(handleError, 150); // debounce
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
